import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricsGrid = () => {
  const metrics = [
    {
      id: 1,
      title: "Password Health Score",
      value: "87%",
      change: "+3%",
      trend: "up",
      status: "good",
      icon: "Shield",
      description: "Overall password strength across organization"
    },
    {
      id: 2,
      title: "Active Breach Alerts",
      value: "12",
      change: "+5",
      trend: "up",
      status: "critical",
      icon: "AlertTriangle",
      description: "Credentials found in recent data breaches"
    },
    {
      id: 3,
      title: "Total Vaults",
      value: "248",
      change: "+8",
      trend: "up",
      status: "good",
      icon: "Vault",
      description: "Active vaults across all departments"
    },
    {
      id: 4,
      title: "Active Users",
      value: "156",
      change: "-2",
      trend: "down",
      status: "neutral",
      icon: "Users",
      description: "Users active in the last 30 days"
    },
    {
      id: 5,
      title: "Shared Items",
      value: "89",
      change: "+12",
      trend: "up",
      status: "good",
      icon: "Share2",
      description: "Items shared internally and externally"
    },
    {
      id: 6,
      title: "Policy Violations",
      value: "7",
      change: "-3",
      trend: "down",
      status: "warning",
      icon: "AlertCircle",
      description: "Security policy violations this month"
    }
  ];

  const getStatusColor = (status) => {
    switch (status) {
      case 'critical': return 'text-error';
      case 'warning': return 'text-warning';
      case 'good': return 'text-success';
      default: return 'text-muted-foreground';
    }
  };

  const getStatusBg = (status) => {
    switch (status) {
      case 'critical': return 'bg-error/10 border-error/20';
      case 'warning': return 'bg-warning/10 border-warning/20';
      case 'good': return 'bg-success/10 border-success/20';
      default: return 'bg-muted/50 border-border';
    }
  };

  const getTrendIcon = (trend) => {
    return trend === 'up' ? 'TrendingUp' : 'TrendingDown';
  };

  const getTrendColor = (trend, status) => {
    if (status === 'critical' && trend === 'up') return 'text-error';
    if (status === 'warning' && trend === 'up') return 'text-warning';
    return trend === 'up' ? 'text-success' : 'text-muted-foreground';
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {metrics?.map((metric) => (
        <div
          key={metric?.id}
          className={`p-6 rounded-lg border transition-smooth hover:shadow-card ${getStatusBg(metric?.status)}`}
        >
          <div className="flex items-start justify-between mb-4">
            <div className={`p-3 rounded-lg ${getStatusBg(metric?.status)}`}>
              <Icon 
                name={metric?.icon} 
                size={24} 
                className={getStatusColor(metric?.status)}
              />
            </div>
            <div className="flex items-center space-x-1">
              <Icon 
                name={getTrendIcon(metric?.trend)} 
                size={16} 
                className={getTrendColor(metric?.trend, metric?.status)}
              />
              <span className={`text-sm font-medium ${getTrendColor(metric?.trend, metric?.status)}`}>
                {metric?.change}
              </span>
            </div>
          </div>
          
          <div className="space-y-2">
            <h3 className="text-sm font-medium text-muted-foreground">
              {metric?.title}
            </h3>
            <p className="text-3xl font-bold text-foreground">
              {metric?.value}
            </p>
            <p className="text-xs text-muted-foreground">
              {metric?.description}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MetricsGrid;